import React, { FC, useEffect } from 'react';
import * as S from './styled';
import { appStore } from '@store';

interface Props {
	children?: any;
	showModal: boolean;
	onClick: any;
}

export const Modal: FC<Props> = props => {
	const { children, showModal, onClick } = props;
	const { product } = appStore.paymentStore;

	return (
		<S.ModalWrapper showModal={showModal}>
			<S.ModalContainer>
				<S.Modal>
					<div>
						<S.Info>
							As part of our commitment to global healthcare, we are providing the opportunity to
							experience Verv with a 7-day trial for only $1*.
						</S.Info>
						<S.Info2>
							Money shouldn’t stand in the way of your weight loss and well-being goals. So choose
							an amount that you think is reasonable to try us out.
						</S.Info2>
						<S.Info3>
							It costs us $9.73 to cover our expenses for the trial, but please choose an amount
							you’re comfortable with.
						</S.Info3>
					</div>
					<S.ButtonWrapper>{children}</S.ButtonWrapper>
					<S.Button disabled={!product.name} onClick={onClick}>
						See my plan
					</S.Button>
					<S.Label>*7-day trial</S.Label>
				</S.Modal>
			</S.ModalContainer>
		</S.ModalWrapper>
	);
};
